import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const SpaceDefenders = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Space Defenders</h1>
        <p>Defend your spaceship in this exciting Python game.</p>
        <ImageWithFallback src="/space_defenders.png" alt="Space Defenders" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project is a space defense game built using Python's Pygame library.</p>
        <h2>Download</h2>
        <a href="/Space defenders.py" download>Download Space defenders.py</a>
        <h2>How to Play</h2>
        <p>Run the Python file and use arrow keys to control your spaceship and shoot enemies.</p>
      </div>
      <footer style={{
        backgroundColor: "#f8f9fa",
        padding: "20px 0",
        textAlign: "center",
        borderTop: "1px solid #e9ecef",
      }}>
        <div>
          <h4>Coding Projects</h4>
          <select style={{ padding: "10px", borderRadius: "5px" }}>
            <option value="games">Games</option>
            <option value="math">Math</option>
            <option value="drawing">Drawing</option>
          </select>
        </div>
        <div style={{ marginTop: "10px" }}>
          <a href="/terms-and-conditions">Terms & Conditions</a>
        </div>
      </footer>
    </div>
  );
};

export default SpaceDefenders;
